"use client";

let pendingSignal = false;
const listeners = new Set<() => void>();

function notifyListeners(): void {
  listeners.forEach((listener) => listener());
}

export const notificationPromptSignalStore = {
  signalUploadComplete(): void {
    pendingSignal = true;
    notifyListeners();
  },

  consumeUploadCompleteSignal(): boolean {
    if (!pendingSignal) return false;
    pendingSignal = false;
    return true;
  },

  subscribe(listener: () => void): () => void {
    listeners.add(listener);
    return () => {
      listeners.delete(listener);
    };
  },
};
